<template>
    <section :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-slate-50'" class="tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden">
        <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-slate-700' : 'tw-bg-[#e9eef6] tw-border-[#d1d5db]'" class="tw-border-b tw-px-6 tw-py-4 tw-flex tw-items-center tw-gap-3 ">
            <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-text-blue-400' : 'tw-bg-blue-50 tw-text-blue-600'" class="tw-p-2.5 tw-rounded-lg ">
                <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>report-text</title> <g id="Page-1" stroke="currentColor" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="add" fill="currentColor" transform="translate(42.666667, 85.333333)"> <path d="M341.333333,1.42108547e-14 L426.666667,85.3333333 L426.666667,341.333333 L3.55271368e-14,341.333333 L3.55271368e-14,1.42108547e-14 L341.333333,1.42108547e-14 Z M330.666667,42.6666667 L42.6666667,42.6666667 L42.6666667,298.666667 L384,298.666667 L384,96 L330.666667,42.6666667 Z M149.333333,234.666667 L149.333333,266.666667 L85.3333333,266.666667 L85.3333333,234.666667 L149.333333,234.666667 Z M341.333333,234.666667 L341.333333,266.666667 L192,266.666667 L192,234.666667 L341.333333,234.666667 Z M149.333333,170.666667 L149.333333,202.666667 L85.3333333,202.666667 L85.3333333,170.666667 L149.333333,170.666667 Z M341.333333,170.666667 L341.333333,202.666667 L192,202.666667 L192,170.666667 L341.333333,170.666667 Z M149.333333,106.666667 L149.333333,138.666667 L85.3333333,138.666667 L85.3333333,106.666667 L149.333333,106.666667 Z M341.333333,106.666667 L341.333333,138.666667 L192,138.666667 L192,106.666667 L341.333333,106.666667 Z" id="Combined-Shape"> </path> </g> </g> </g></svg>
            </div>
            <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold ">Informações Gerais dos Silos</h3>
        </div>
        <div class="md:tw-hidden tw-divide-y" :class="theme === 'dark' ? 'tw-divide-slate-700/60' : 'tw-divide-slate-200'">
            <div
                v-for="silo in silos"
                :key="silo.id"
                @click="$router.push(`/v2/unidades/${unidade.id}/silos/${silo.id}`)"
                :class="theme === 'dark' ? 'tw-text-slate-300 active:tw-bg-slate-800/40' : 'tw-text-slate-700 active:tw-bg-slate-100'"
                class="tw-p-4 tw-cursor-pointer tw-space-y-3"
            >
                <div class="tw-flex tw-items-center tw-gap-3">
                    <div class="tw-min-w-0 tw-flex-1">
                        <span class="tw-block tw-font-bold tw-truncate">{{ silo.nome }}</span>
                        <span class="tw-text-xs tw-text-gray-400"><template v-if="isAdmin">ID: #{{ silo.id }} • </template>{{ silo.ultimaleitura ? silo.ultimaleitura.produto : '—' }}</span>
                    </div>
                    <span :class="getStatus(silo) === 'Erro' ? (theme === 'dark' ? 'tw-bg-red-500/10 tw-text-red-400' : 'tw-bg-red-50 tw-text-red-600') : (theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-600')" :title="descricaoStatus(silo)" class="tw-inline-block tw-px-2.5 tw-py-1 tw-rounded-full tw-text-[10px] tw-font-semibold tw-uppercase tw-shrink-0">{{ getStatus(silo) }}</span>
                    <i class="fa-solid fa-chevron-right tw-text-gray-400 tw-text-xs tw-shrink-0"></i>
                </div>
                <div>
                    <div class="tw-grid tw-grid-cols-3 tw-text-center tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase tw-mb-1">
                        <span>Mín</span><span>Méd</span><span>Máx</span>
                    </div>
                    <div class="tw-grid tw-grid-cols-3 tw-gap-1.5 tw-text-xs tw-font-semibold tw-text-center">
                        <span v-for="t in temperaturasSilo(silo)" :key="t.chave" class="tw-py-1 tw-rounded-md" :style="{ backgroundColor: t.cor, color: t.texto }">{{ t.valor }}°</span>
                    </div>
                </div>
                <div class="tw-space-y-1">
                    <div class="tw-flex tw-justify-between tw-items-baseline tw-text-xs">
                        <span class="tw-text-gray-400">Nível</span>
                        <span class="tw-font-bold">{{ (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) % 1 === 0 ? (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) : (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual).toFixed(1) }}%</span>
                    </div>
                    <div :class="theme === 'dark' ? 'tw-bg-slate-600' : 'tw-bg-slate-200'" class="tw-w-full tw-h-2 tw-rounded-full tw-overflow-hidden">
                        <div class="tw-h-full tw-bg-emerald-500" :style="{ width: (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) + '%' }"></div>
                    </div>
                    <div class="tw-text-[11px] tw-text-gray-400 tw-text-right">{{ formatarNumero(((silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) / 100) * parseInt(silo.capacidade)) }} / {{ formatarNumero(silo.capacidade) }}</div>
                </div>
                <div class="tw-flex tw-flex-wrap tw-justify-between tw-gap-x-4 tw-gap-y-1 tw-text-xs tw-text-gray-400">
                    <span>Últ. registro: <span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-600'" class="tw-font-medium">{{ silo.ultimaleitura ? silo.ultimaleitura.data : '—' }}</span></span>
                    <span>Aeração 24h: <span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-600'" class="tw-font-medium">{{ silo.existe_aeracao == 1 ? silo.aeracaoultimas24horas : 'Sem aeração' }}</span></span>
                    <span v-if="motoresSilo(silo)">Motores: <span :class="motoresSilo(silo).ligados > 0 ? (theme === 'dark' ? 'tw-text-emerald-400' : 'tw-text-emerald-600') : (theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-600')" class="tw-font-medium">{{ motoresSilo(silo).ligados }}/{{ motoresSilo(silo).total }} ligados</span></span>
                </div>
            </div>
        </div>

        <div class="tw-hidden md:tw-block tw-overflow-x-auto custom-scrollbar">
            <table class="tw-w-full">
                <thead>
                    <tr>
                        <th v-if="isAdmin" rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-[14px] tw-font-semibold tw-uppercase tw-tracking-wider">ID</th>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-[14px] tw-font-semibold tw-uppercase tw-tracking-wider">Local</th>
                        <th :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-4 tw-pt-3 tw-pb-1 tw-text-center tw-text-[14px] tw-font-semibold tw-uppercase tw-tracking-wider">Sensores (°C)</th>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-[14px] tw-font-semibold tw-uppercase tw-tracking-wider">Aeração últimas 24h</th>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-[14px] tw-font-semibold tw-uppercase tw-tracking-wider">Motores</th>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-[14px] tw-font-semibold tw-uppercase tw-tracking-wider">Nível</th>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-[14px] tw-font-semibold tw-uppercase tw-tracking-wider">Status</th>
                    </tr>
                    <tr>
                        <td :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-px-4 tw-pb-2 tw-text-[12px] tw-font-medium tw-uppercase">
                            <div class="tw-grid tw-grid-cols-3 tw-gap-1 tw-w-48 tw-mx-auto tw-text-center"><span>Mín</span><span>Méd</span><span>Máx</span></div>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr 
                        v-for="silo in silos" 
                        :key="silo.id" 
                        :class="theme === 'dark' ? 'hover:tw-bg-slate-800/30 tw-border-slate-700' : 'hover:tw-bg-slate-50 tw-border-slate-200'"
                        class="tw-border-t  tw-cursor-pointer"
                        @click="$router.push(`/v2/unidades/${unidade.id}/silos/${silo.id}`)"
                    >
                        <td v-if="isAdmin" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-center tw-px-6 tw-py-4 tw-text-[16px]">{{ silo.id }}</td>
                        <td :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-center tw-px-6 tw-py-4 tw-text-[16px]">
                            <div class="tw-font-medium">{{ silo.nome }}</div>
                            <div v-if="silo.ultimaleitura && silo.ultimaleitura.produto" :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-text-[14px]">{{ silo.ultimaleitura.produto }}</div>
                        </td>
                        <td class="tw-px-4 tw-py-4 tw-text-center">
                            <!-- Mín/Méd/Máx numa só coluna: três etiquetas compactas lado a lado -->
                            <div class="tw-grid tw-grid-cols-3 tw-gap-1 tw-w-48 tw-mx-auto tw-text-[14px] tw-font-semibold">
                                <span v-for="t in temperaturasSilo(silo)" :key="t.chave" class="tw-py-1 tw-rounded-md" :style="{ backgroundColor: t.cor, color: t.texto }">{{ t.valor }}</span>
                            </div>
                            <div v-if="silo.ultimaleitura && silo.ultimaleitura.data" :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-mt-1 tw-text-[13px] tw-whitespace-nowrap" title="Último registro">{{ silo.ultimaleitura.data }}</div>
                        </td>
                        <td :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-4 tw-text-center tw-text-[16px] ">{{ silo.existe_aeracao == 1 ? silo.aeracaoultimas24horas : 'Sem aeração' }}</td>
                        <td class="tw-px-6 tw-py-4 tw-text-center tw-text-[16px]">
                            <span
                                v-if="motoresSilo(silo)"
                                :class="motoresSilo(silo).ligados > 0
                                    ? (theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-700')
                                    : (theme === 'dark' ? 'tw-bg-slate-700/40 tw-text-slate-400' : 'tw-bg-slate-100 tw-text-slate-600')"
                                class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-2.5 tw-py-1 tw-rounded-full tw-text-[14px] tw-font-semibold tw-whitespace-nowrap"
                            >
                                {{ motoresSilo(silo).ligados }}/{{ motoresSilo(silo).total }} ligados
                            </span>
                            <span v-else :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'">—</span>
                        </td>
                        <td class="tw-px-6 tw-py-4 tw-text-[16px]">
                            <div class="tw-space-y-1">
                                <div :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-[14px] tw-text-center ">{{ (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) % 1 === 0 ? (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) : (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual).toFixed(1) }}%</div>
                                <div :class="theme === 'dark' ? 'tw-bg-slate-600' : 'tw-bg-slate-200'" class="tw-w-full tw-h-2 tw-rounded-full tw-overflow-hidden">
                                    <div class="tw-h-full tw-bg-emerald-500" :style="{ width: (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) + '%' }"></div>
                                </div>
                                <div :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-600'" class="tw-text-center tw-text-[14px] ">{{ formatarNumero(((silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) / 100) * parseInt(silo.capacidade)) }} / {{ formatarNumero(silo.capacidade) }}</div>
                            </div>
                        </td>
                        <td class="tw-px-6 tw-py-4 tw-text-[16px] tw-text-center">
                            <span :class="getStatus(silo) === 'Erro' ? (theme === 'dark' ? 'tw-bg-red-500/10 tw-text-red-400' : 'tw-bg-red-50 tw-text-red-600') : (theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-600')" :title="descricaoStatus(silo)" class="tw-inline-block tw-px-3 tw-py-1 tw-rounded-full tw-text-[14px] tw-font-semibold tw-uppercase">{{ getStatus(silo) }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script>
import temperaturaCores from "@/assets/colors.json";
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
    name: 'DashboardTable',
    props: {
        silos: {
            type: Object,
            required: true
        },
        unidade: {
            type: Object,
            required: true
        }
    },

    setup() {
        const store = useStore();
        const theme = computed(() => store.state.ui.theme);
        const getCorPorTemperatura = (temp) => {
			temp = Number(temp);

            const faixas = Object.keys(temperaturaCores)
                .map(Number)
                .sort((a, b) => a - b);            

            for (let i = 0; i <= faixas.length - 1; i++) {
                if (temp <= faixas[i]) {
                    return temperaturaCores[faixas[i]];
                }
            }

            return "#c31313";
		};

        const getTextoContraste = (hex) => {
            if (!hex) return '#ffffff';
            let c = String(hex).replace('#', '');
            if (c.length === 3) c = c.split('').map((x) => x + x).join('');
            const r = parseInt(c.substring(0, 2), 16);
            const g = parseInt(c.substring(2, 4), 16);
            const b = parseInt(c.substring(4, 6), 16);
            const yiq = (r * 299 + g * 587 + b * 114) / 1000;
            return yiq >= 128 ? '#1e293b' : '#ffffff';
        };

        const estiloSensor = (temp) => {
            const bg = getCorPorTemperatura(temp);
            return { backgroundColor: bg, color: getTextoContraste(bg) };
        };

        const temperaturasSilo = (silo) => ['min', 'med', 'max'].map(chave => {
            const valor = silo.ultimaleitura ? silo.ultimaleitura.maxmedmin[chave] : 0;
            const cor = getCorPorTemperatura(valor);
            return { chave, valor: silo.ultimaleitura ? valor : '0', cor, texto: getTextoContraste(cor) };
        });

        const motoresSilo = (silo) => {
            const motores = silo.existe_aeracao == 1 && Array.isArray(silo.aeracao?.motores) ? silo.aeracao.motores : [];
            if (!motores.length) return null;
            return { ligados: motores.filter(m => m.status == 1).length, total: motores.length };
        };

        const isAdmin = computed(() => store.getters['auth/getUser']?.tipo_usuario === 'administrador');

        const getStatus = (silo) => {
			if (!silo.ultimaleitura || !silo.ultimaleitura.data) return 'Erro';
			const ultimoRegistroStr = silo.ultimaleitura.data;
			
			const [date, time] = ultimoRegistroStr.split(' ');
			const [day, month, year] = date.split('/');
			const [hours, minutes, seconds] = time.split(':');

			const ultimoRegistro = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
			const dataAtual = new Date();
			const diffTime = Math.abs(dataAtual - ultimoRegistro);
			const diffHours = diffTime / (1000 * 3600);
			return diffHours > 12 ? 'Erro' : 'Sucesso';
		};

		const descricaoStatus = (silo) => (getStatus(silo) === 'Erro'
			? 'Silo há pelo menos 12 horas sem atualizações'
			: 'Silo com dados atualizados');

		const getStatusClass = (silo) => {
			return getStatus(silo) === 'Erro' ? 'text-error' : 'text-success';
		};

        const formatarNumero = (numero) => {
			let numeroInt = parseInt(numero);
			return new Intl.NumberFormat('pt-BR').format(numeroInt);
		};

        return {
            getCorPorTemperatura,
            estiloSensor,
            temperaturasSilo,
            motoresSilo,
            isAdmin,
            getStatus,
            descricaoStatus,
            getStatusClass,
            formatarNumero,
            theme
        }
    }
}
</script>